/* eslint-disable react/no-multi-comp */
import classNames from 'classnames';
import * as React from 'react';
import Anchor from '@restart/ui/Anchor';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultProps = {
  active: false,
  disabled: false,
  activeLabel: '(current)'
};
const PageItem = /*#__PURE__*/React.forwardRef(({
  active,
  disabled,
  className,
  style,
  activeLabel,
  children,
  ...props
}, ref) => {
  const Component = active || disabled ? 'span' : Anchor;
  return /*#__PURE__*/_jsx("li", {
    ref: ref,
    style: style,
    className: classNames(className, 'page-item', {
      active,
      disabled
    }),
    children: /*#__PURE__*/_jsxs(Component, {
      className: "page-link",
      disabled: disabled,
      ...props,
      children: [children, active && activeLabel && /*#__PURE__*/_jsx("span", {
        className: "visually-hidden",
        children: activeLabel
      })]
    })
  });
});
PageItem.defaultProps = defaultProps;
PageItem.displayName = 'PageItem';
export default PageItem;

function createButton(name, defaultValue, label = name) {
  function Button({
    children,
    ...props
  }) {
    return /*#__PURE__*/_jsxs(PageItem, { ...props,
      children: [/*#__PURE__*/_jsx("span", {
        "aria-hidden": "true",
        children: children || defaultValue
      }), /*#__PURE__*/_jsx("span", {
        className: "visually-hidden",
        children: label
      })]
    });
  }

  Button.displayName = name;
  return Button;
}

const PaginationPrevIcon = () => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.963",
  height: "11.652",
  viewBox: "0 0 5.963 11.652",
  children: /*#__PURE__*/_jsx("path", {
    id: "Path_21615",
    "data-name": "Path 21615",
    d: "M0,0,4.42,3.556,8.84,0",
    transform: "translate(4.556 1.406) rotate(90)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  })
});

const PaginationNextIcon = () => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "6.119",
  height: "11.658",
  viewBox: "0 0 6.119 11.658",
  children: /*#__PURE__*/_jsx("path", {
    id: "Path_21616",
    "data-name": "Path 21616",
    d: "M0,0,4.42,3.71,8.84,0",
    transform: "translate(1.409 10.249) rotate(-90)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  })
});

export const First = createButton('First', '«');
export const Prev = createButton('Prev', /*#__PURE__*/_jsx(PaginationPrevIcon, {}), 'Previous');
export const Ellipsis = createButton('Ellipsis', '…', 'More');
export const Next = createButton('Next', /*#__PURE__*/_jsx(PaginationNextIcon, {}));
export const Last = createButton('Last', '»');